export default __webpack_public_path__ + "static/media/polka_dots.317a5469.jpg";